<script type="text/ecmascript-6">
    import DesignerQuestionDoorRange from "../DesignerQuestionDoorRange.vue";

    export default {
        mixins: [
            DesignerQuestionDoorRange
        ],
        computed: {
            thumbURL() {
                return '/images/senator/';
            },
        },
    }
</script>
